import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ServerResponseService } from '@scalefast/ecommerce-core';
import { MetaTagsService } from 'src/app/shared/services';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  imports: [RouterLink],
})
export class AppPageNotFoundComponent implements OnInit {
  constructor(
    private metaTags: MetaTagsService,
    private serverResponseService: ServerResponseService,
  ) {}

  ngOnInit() {
    // TODO: Remove commented code once no side effect is found
    //this.router.navigateByUrl(this.router.url);

    this.metaTags.setMetaTags({
      page: '404',
      robots: 'noindex,follow',
    });

    this.serverResponseService.setNotFound();
  }
}
